import '@agilepoint/icons-generic';
import * as React from 'react';
import { ApIcon } from '@agilepoint/web-components-react';
import styled from 'styled-components';
import { IIconProps } from './types';

const IconBase = React.memo((props: IIconProps) => {
    const { iconName, iconSize = '16', hidden, ...rest } = props;
    return hidden ? null : (
        <ApIcon icon={iconName} iconSize={iconSize} {...rest} />
    );
});

IconBase.displayName = 'IconBase';

export const Icon = styled(IconBase).attrs(() => ({
    className: String('ap-icon')
}))`
    display: inline-flex;
    box-sizing: border-box;
    flex-grow: 0;
    flex-shrink: 0;
    fill: ${({ theme: { icon: { colors } } }) => colors.foregroundColor};
    background-color:  ${({ theme: { icon: { colors } } }) => colors.backgroundColor};
    border-color: ${({ theme: { icon } }) => icon.colors.borderColor};
    border-width: ${({ theme: { icon } }) => icon.composites.borderWidth};
    border-style: ${({ theme: { icon } }) => icon.composites.borderStyle};
    border-radius: ${({ theme: { icon: { composites } } }) => composites.borderRadius};
`;
